export const enum TRACKING_CATEGORY {
  buttonClick = 'Button Click',
}
